@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

@sidebarWidth: 315px;
@ftu-header-offset: 169px; // Height of header + navigation + any other fixed elements

.drawer-canvas {
  background-color: var(--white);
  height: 100%;
}

.ftu-drawer-header {
  background-color: var(--white);
}

.ftu-wizard-pane {
  display: grid;
  grid-template-columns: @sidebarWidth 1fr;
  width: 100%;
  flex: 1;
  min-height: 0;
  align-items: self-start;

  @media @mobile {
    display: flex;
    flex-direction: column;
    grid-template-columns: none;
    grid-template-rows: none;
  }
}

.ftu-wizard-sidebar {
  background-color: var(--green-00331C);
  padding: @space-40;
  max-width: @sidebarWidth;
  height: 100%;
  justify-content: flex-start;
  overflow: auto;

  @media @mobile {
    overflow: hidden;
    max-width: none;
    width: 100%;
    height: 100px;
    padding: @space-12 @space-16;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    order: 1;
    background-color: var(--white);
  }
}

.ftu-wizard-stepper {
  justify-content: center;
  margin: @space-40 0;

  @media @mobile {
    margin: 0;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}

.ftu-wizard-content {
  background-color: var(--gray-F7F7F8);
  text-align: center;
  padding: @space-40 @space-0;
  height: 100%;
  overflow: hidden auto;

  @media @mobile {
    padding: @space-24 @space-16;
    height: calc(100vh - @ftu-header-offset - 68px - 65px - 24px);
    flex: 1;
    order: 2;
  }
}

.ftu-wizard-step {
  max-width: 1200px;
  padding: @space-0 @space-40;
  margin: auto;
  &-title {
    font-weight: 700;
    text-align: left;
  }
  &-description {
    text-align: left;
    margin-top: @space-4;
    color: var(--grey-900);
  }
  &-body {
    margin-top: @space-40;
  }
}

.ftu-wizard-footer {
  height: 60px;
  align-items: center;
  padding: @space-16 @space-24;
  flex-shrink: 0;
  background-color: var(--white);
  border-top: 1px solid var(--grey-300);
}
